import { axiosInstance } from "@/api/index";
import { IServerResponse } from "@/api/types";
import { API_NOTES_URL } from "@/configs/global";
import { AxiosResponse } from "axios";
import { CreateNoteData, EditNoteData, Note, NotesListQuery } from "@/api/types/notes";

export async function createNote(data: CreateNoteData): Promise<IServerResponse<{ id: number }>> {
    return axiosInstance.request<IServerResponse<{ id: number }>>({
        method: 'POST',
        url: `${API_NOTES_URL}/employees/notes`,
        data,
    }).then((response: AxiosResponse<IServerResponse<{ id: number }>>) => response.data);
}

export async function editNote(id: number, data: EditNoteData): Promise<IServerResponse<{ id: number }>> {
    return axiosInstance.request<IServerResponse<{ id: number }>>({
        method: 'PATCH',
        url: `${API_NOTES_URL}/employees/notes/${id}`,
        data,
    }).then((response: AxiosResponse<IServerResponse<{ id: number }>>) => response.data);
}

export async function deleteNote(id: number): Promise<IServerResponse<any>> {
    return axiosInstance.request<IServerResponse<any>>({
        method: 'DELETE',
        url: `${API_NOTES_URL}/employees/notes/${id}`,
    }).then((response: AxiosResponse<IServerResponse<any>>) => response.data);
}

export async function getOneNote(id: number): Promise<IServerResponse<Note>> {
    return axiosInstance.request<IServerResponse<Note>>({
        method: 'GET',
        url: `${API_NOTES_URL}/employees/notes/${id}`,
    }).then((response: AxiosResponse<IServerResponse<Note>>) => response.data);
}

export async function getNotesList(params: NotesListQuery): Promise<IServerResponse<Note[]>> {
    return axiosInstance.request<IServerResponse<Note[]>>({
        method: 'GET',
        url: `${API_NOTES_URL}/employees/notes`,
        params,
    }).then((response: AxiosResponse<IServerResponse<Note[]>>) => response.data);
}
